import { useTheme } from "../../../contexts/ThemeContext";

const PLATFORMS = [
  { name: "eBay", icon: "ri-store-2-line", fee: "13.25% + payment", category: "Marketplace" },
  { name: "StockX", icon: "ri-exchange-line", fee: "9–10% + fee", category: "Sneakers / Cards" },
  { name: "GOAT", icon: "ri-shoe-line", fee: "9.5% + payment", category: "Sneakers" },
  { name: "Poshmark", icon: "ri-shirt-line", fee: "20% over $15", category: "Clothing" },
  { name: "Depop", icon: "ri-shopping-bag-line", fee: "10% + processing", category: "Clothing" },
  { name: "Mercari", icon: "ri-price-tag-3-line", fee: "10% + processing", category: "Marketplace" },
  { name: "Facebook", icon: "ri-facebook-circle-line", fee: "5% or $0.40 min", category: "Social Sell" },
  { name: "Amazon", icon: "ri-amazon-line", fee: "8–15% category", category: "Marketplace" },
  { name: "Whatnot", icon: "ri-live-line", fee: "8% commission", category: "Live Auctions" },
  { name: "Goldin", icon: "ri-auction-line", fee: "10% buyer + sell", category: "Premium Cards" },
  { name: "OfferUp", icon: "ri-hand-coin-line", fee: "12.9% + shipping", category: "Local / National" },
  { name: "PWCC", icon: "ri-medal-line", fee: "15% final value", category: "Sports Cards" },
];

export default function IntegrationsSection() {
  const { isDark } = useTheme();

  return (
    <section id="integrations" className={`py-24 px-8 lg:px-16 border-t transition-colors duration-300 ${isDark ? "bg-[#080808] border-white/5" : "bg-[#f8f8f8] border-black/5"}`}>
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-14">
          <div>
            <span className={`font-inter text-xs uppercase tracking-[0.2em] block mb-4 ${isDark ? "text-[#666666]" : "text-[#888888]"}`}>
              Supported Platforms
            </span>
            <h2 className={`font-syne font-bold text-5xl ${isDark ? "text-white" : "text-[#111111]"}`}>
              Every platform, <br />
              <span className={isDark ? "text-[#444444]" : "text-[#cccccc]"}>every fee — pre-loaded.</span>
            </h2>
            <p className={`font-inter text-base mt-4 max-w-md ${isDark ? "text-[#555555]" : "text-[#666666]"}`}>
              Trackly knows the exact fee structure for every major selling platform — from marketplace giants to niche reseller apps. No manual lookup. No outdated rates. Just accurate math, every time.
            </p>
          </div>
          <div className={`flex items-center gap-2 border rounded-full px-4 py-2 w-fit h-fit ${isDark ? "bg-white/5 border-white/8" : "bg-black/4 border-black/8"}`}>
            <span className={`font-syne font-bold text-sm ${isDark ? "text-white" : "text-[#111111]"}`}>12+</span>
            <span className={`font-inter text-xs ${isDark ? "text-[#666666]" : "text-[#777777]"}`}>platforms supported</span>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4">
          {PLATFORMS.map((p) => (
            <div
              key={p.name}
              className={`border rounded-xl p-5 flex flex-col items-center gap-3 transition-all duration-300 cursor-default ${
                isDark
                  ? "bg-[#0d0d0d] border-white/5 hover:border-white/10 hover:bg-[#111111]"
                  : "bg-white border-black/5 hover:border-black/10 hover:bg-[#f5f5f5]"
              }`}
            >
              <div className="w-10 h-10 flex items-center justify-center">
                <i className={`${p.icon} text-xl ${isDark ? "text-[#555555]" : "text-[#999999]"}`} />
              </div>
              <div className="text-center">
                <p className={`font-inter text-xs ${isDark ? "text-white" : "text-[#111111]"}`}>{p.name}</p>
                <p className={`font-inter text-xs mt-0.5 ${isDark ? "text-[#444444]" : "text-[#aaaaaa]"}`}>{p.fee}</p>
                <p className={`font-inter text-xs mt-0.5 ${isDark ? "text-[#333333]" : "text-[#bbbbbb]"}`}>{p.category}</p>
              </div>
            </div>
          ))}
        </div>

        <p className={`font-inter text-xs text-center mt-8 ${isDark ? "text-[#444444]" : "text-[#aaaaaa]"}`}>
          Fee structures updated regularly. More platforms added based on community requests.
        </p>
      </div>
    </section>
  );
}
